import { isMobileOnly } from "react-device-detect";

export interface TableOfContentsEntry {
  sectionHeadingId: string;
  title: string;
}

const getSectionHeadingIdForElement = (element: HTMLElement, index: number) =>
  `${index + 1}-${element.innerText
    .toLowerCase()
    .replace(/\W/g, "-")
    .replace(/-+/g, "-")}`;

const prepareTableOfContents = (contentDocument: Document) => {
  const tableOfContents: TableOfContentsEntry[] = [];

  const sectionHeadings =
    contentDocument.querySelectorAll<HTMLHeadingElement>("h1, h2");
  sectionHeadings.forEach((sectionHeading, i) => {
    const sectionHeadingId = getSectionHeadingIdForElement(sectionHeading, i);
    sectionHeading.setAttribute("id", sectionHeadingId);

    tableOfContents.push({
      sectionHeadingId,
      title: sectionHeading.innerText,
    });
  });

  const paragraphs = contentDocument.querySelectorAll("p");
  paragraphs.forEach((paragraph) => {
    const { innerText } = paragraph;
    if (innerText.includes("[TRY_ORCHID_BANNER]")) {
      paragraph.innerHTML = "";

      const banner = document.createElement("div");
      banner.setAttribute("class", "try-orchid-banner");
      banner.innerHTML = !isMobileOnly
        ? `
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://orchid.exchange/about-us"
        >
          <img width="100%" height="auto" src="/img/blog/try-orchid-banner.png" alt="Try Orchid" />
        </a>
      `
        : `
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://orchid.exchange/about-us"
        >
          <img width="100%" height="auto" src="/img/blog/try-orchid-banner-phone.png" alt="Try Orchid" />
        </a>
      `;

      paragraph.appendChild(banner);
    } else if (innerText.includes("[BLOG_72_TRY_ORCHID_BANNER]")) {
      paragraph.innerHTML = "";

      const banner = document.createElement("div");
      banner.setAttribute("class", "try-orchid-banner");
      banner.innerHTML = !isMobileOnly
        ? `
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://orchid.exchange/about-us"
        >
          <img width="100%" height="auto" src="/img/blog/blog-72/try-orchid-banner.png" alt="Try Orchid" />
        </a>
      `
        : `
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://orchid.exchange/about-us"
        >
          <img width="100%" height="auto" src="/img/blog/blog-72/try-orchid-banner-phone.png" alt="Try Orchid" />
        </a>
      `;

      paragraph.appendChild(banner);
    }
  });

  const enhancedContent = contentDocument.body.innerHTML;
  return { enhancedContent, tableOfContents };
};

export default prepareTableOfContents;
